import { render, staticRenderFns } from "./shipping_progress_bar.vue?vue&type=template&id=0876cff6"
import script from "./shipping_progress_bar.vue?vue&type=script&lang=js"
export * from "./shipping_progress_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0876cff6')) {
      api.createRecord('0876cff6', component.options)
    } else {
      api.reload('0876cff6', component.options)
    }
    module.hot.accept("./shipping_progress_bar.vue?vue&type=template&id=0876cff6", function () {
      api.rerender('0876cff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/shipping_progress_bar.vue"
export default component.exports